"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var findOverboundElement = function findOverboundElement(children, right) {
  var index = Array.from(children).findIndex(function (child) {
    var rect = child.getBoundingClientRect();
    return rect.left + rect.width > right;
  });
  return index >= 0 ? index : null;
};

var AutohideList =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(AutohideList, _React$PureComponent);

  function AutohideList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AutohideList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutohideList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "resize", function () {
      _this.setState({
        count: null
      });

      _this.element && _this.calc(_this.element);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "wrapper", function (element) {
      _this.element = element;

      _this.resize();
    });
    return _this;
  }

  (0, _createClass2.default)(AutohideList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.resize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: "calc",
    value: function calc(element) {
      var rect = element.parentNode.getBoundingClientRect();
      var index = findOverboundElement(element.children, rect.right - 50);
      this.setState({
        count: index
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(count) {
      return _react.default.Children.toArray(this.props.children).map(function (element, index) {
        if (index >= count) {
          return _react.default.createElement("div", {
            className: "hidden",
            key: 'hidden$' + index
          }, element);
        }

        return element;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var length = this.length;
      var count = this.state.count || length;
      return _react.default.createElement("div", {
        className: className
      }, _react.default.createElement("span", {
        ref: this.wrapper
      }, this.renderChildren(count)), count < length ? _react.default.createElement("span", {
        className: "more"
      }, "...".concat(length - count)) : null);
    }
  }, {
    key: "length",
    get: function get() {
      var _this$props = this.props,
          listLength = _this$props.listLength,
          children = _this$props.children;
      return listLength ? listLength : children.length;
    }
  }]);
  return AutohideList;
}(_react.default.PureComponent);

exports.default = AutohideList;
AutohideList.propTypes = process.env.NODE_ENV !== "production" ? {
  listLength: _propTypes.default.number
} : {};